export default __webpack_public_path__ + "static/media/54215033bb693e987c01fd288229aec.f3f4eb6f.png";